import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const AUTHENTICATION_INITIAL: AUTHENTICATION = {
  createdAt: null,
  updatedAt: null,
  removedAt: null,
  token: null,
  error: null,
  nextStep: null,
};

const authenticationSlice = createSlice({
  name: "authentication",
  initialState: {
    ...AUTHENTICATION_INITIAL,
  },
  reducers: {
    AUTHENTICATION_UPDATE: (
      state,
      action: PayloadAction<{
        data?: Partial<AUTHENTICATION>;
        prop?: string;
        value?: string | Date;
      }>,
    ) => {
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? { [action.payload.prop]: action.payload.value } : null),
      });
    },
  },
});

const { AUTHENTICATION_UPDATE } = authenticationSlice.actions;

export { authenticationSlice, AUTHENTICATION_INITIAL, AUTHENTICATION_UPDATE };
